import { type App } from 'vue'
import AppButton from './app-button.vue'
import AppCheckbox from './app-checkbox.vue'
import AppDatepicker from './app-datepicker.vue'
import AppDiscount from './app-discount.vue'
import AppErrorMsg from './app-error-msg.vue'
import AppInput from './app-input.vue'
import AppInputNumber from './app-input-number.vue'
import AppInputPassword from './app-input-password.vue'
import AppInputTel from './app-input-tel.vue'
import AppLoadingDot from './app-loading-dot.vue'
import AppNotice from './app-notice.vue'
import AppPagination from './app-pagination.vue'
import AppRouterView from './app-router-view.vue'
import AppSearch from './app-search.vue'
import AppSelect from './app-select.vue'
import AppSubmit from './app-submit.vue'
import AppSwitch from './app-switch.vue'
import AppTable from './app-table.vue'
import AppTextPhone from './app-text-phone.vue'
import AppTimepicker from './app-timepicker.vue'
import Charts from './charts'
import Dropdown from './dropdown'
import FaIcon from './fa-icon.vue'
import Modal from './modal'

export default {
  install (app: App) {
    app.component('AppButton', AppButton)
    app.component('AppCheckbox', AppCheckbox)
    app.component('AppDatepicker', AppDatepicker)
    app.component('AppDiscount', AppDiscount)
    app.component('AppErrorMsg', AppErrorMsg)
    app.component('AppInput', AppInput)
    app.component('AppInputNumber', AppInputNumber)
    app.component('AppInputPassword', AppInputPassword)
    app.component('AppInputTel', AppInputTel)
    app.component('AppLoadingDot', AppLoadingDot)
    app.component('AppNotice', AppNotice)
    app.component('AppPagination', AppPagination)
    app.component('AppRouterView', AppRouterView)
    app.component('AppSearch', AppSearch)
    app.component('AppSelect', AppSelect)
    app.component('AppSubmit', AppSubmit)
    app.component('AppSwitch', AppSwitch)
    app.component('AppTable', AppTable)
    app.component('AppTextPhone', AppTextPhone)
    app.component('AppTimepicker', AppTimepicker)
    app.component('FaIcon', FaIcon)
    app.use(Modal)
    app.use(Dropdown)
    app.use(Charts)
  },
}

declare module 'vue' {
  export interface GlobalComponents {
    AppButton: typeof AppButton,
    AppCheckbox: typeof AppCheckbox,
    AppDatepicker: typeof AppDatepicker,
    AppDiscount: typeof AppDiscount,
    AppErrorMsg: typeof AppErrorMsg,
    AppInput: typeof AppInput,
    AppInputNumber: typeof AppInputNumber,
    AppInputPassword: typeof AppInputPassword,
    AppInputTel: typeof AppInputTel,
    AppLoadingDot: typeof AppLoadingDot,
    AppNotice: typeof AppNotice,
    AppPagination: typeof AppPagination,
    AppRouterView: typeof AppRouterView,
    AppSearch: typeof AppSearch,
    AppSelect: typeof AppSelect,
    AppSubmit: typeof AppSubmit,
    AppSwitch: typeof AppSwitch,
    AppTable: typeof AppTable,
    AppTextPhone: typeof AppTextPhone,
    AppTimepicker: typeof AppTimepicker,
    FaIcon: typeof FaIcon,
  }
}
